import type { RouteRecordRaw } from 'vue-router'
import { deviceType, page, layout } from '@/router/routes/utils'
import { DeviceType } from '@/api/client'
import { areas } from '../areas'
import { BarBackgroundStyle } from '@/composables/useNativeStyle'

const teamDeviceRoutes: Array<RouteRecordRaw> = deviceType(
  [DeviceType.TEAM],
  [
    {
      path: '/teamleaderSelection',
      name: 'teamleaderSelection',
      meta: {
        isStateful: true,
        showHeader: false,
        showFooter: false,
        showGradient: true,
        disableNativeBackButton: true,
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.WHITE,
      },
      component: page('team-device/TeamleaderSelectionPage'),
    },
    {
      path: '/employeeSelection',
      name: 'employeeSelection',
      meta: {
        headerTitle: 'phrases.my_area',
        showPill: false,
        area: areas.MY_AREA,
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.WHITE,
      },
      component: page('team-device/EmployeeSelectionPage'),
    },
  ],
)

const routesWithDefaultLayout = [
  {
    path: '',
    component: layout('PageLayout'),
    children: [...teamDeviceRoutes],
  },
]

export default [...routesWithDefaultLayout]
